<template>
  <div>
    <div
      v-for="(item, index) in resultData.data"
      :key="`search-result-item-${index}`"
      class="mb-3"
    >
      <callout ref="callout" :controlled="true" :has-toggle="false">
        <div class="row">
          <div class="col-md-2 col-sm-12 border-right pr-3 pt-3">
            <div class="text-center">
              <custom-balloon
                :background-color="
                  ` bg-${getColorStatus(item.requisitionStatus)}`
                "
                class="w-md-90 w-100 m-0"
                :text="item.requisitionStatus.name"
              />
            </div>
          </div>
          <div class="col-md-10 py-2 px-4">
            <div class="row">
              <div class="col-md-3 pl-md-4">
                <div class="data-label">Número de Requisición:</div>
                <span class="data">{{ item.requisitionNumber }}</span>
              </div>
              <div class="col-md-3">
                <div class="data-label">Tipo de Requisición:</div>
                <span class="data">{{ item.requisitionType.name }}</span>
              </div>
              <div class="col-md-2">
                <div class="data-label">Fecha de Requisición:</div>
                <span class="data">{{ item.requisitionDate | date }}</span>
              </div>
              <div class="col-md-2">
                <div class="data-label">Artículos:</div>
                <span class="data">{{ item.articlesCount }}</span>
              </div>
              <div class="col-md-2 d-flex">
                <drop-down
                  class="align-self-center"
                  :data-item="{ item, index }"
                  :items="actionItems(item)"
                />
              </div>
            </div>
          </div>
        </div>
      </callout>
    </div>
    <pagination
      v-if="showPagination"
      :data="resultData.pagination"
      :page-size="20"
      :show-text="true"
      @pagination-go-page="onPageChange"
    />
  </div>
</template>

<script>
import Callout from 'custom-callout';
import Pagination from 'pagination';
import DropDown from 'dropdown';
import alert from '@/mixin/alert.mixin';
import CustomBalloon from 'custom-balloon';

export default {
  name: 'SearchResult',
  mixins: [alert],
  components: {
    Callout,
    Pagination,
    DropDown,
    CustomBalloon,
  },
  props: {
    resultData: {
      type: Object,
      default: () => ({
        data: [],
        pagination: {},
      }),
    },
  },
  data: () => ({
    selectedOption: null,
  }),
  computed: {
    showPagination() {
      return (
        this.resultData.data.length > 0 &&
        this.resultData.pagination.totalItemCount >
          this.resultData.pagination.perPage
      );
    },
    actionItems() {
      return (item) => {
        const actions = [];
        actions.push({
          label: 'Entrar',
          icon: 'fas fa-file-import color-primary-1',
          class: 'border-bottom',
          click: () => this.goToEdit(item.id),
        });
        return actions;
      };
    },
  },
  methods: {
    getColorStatus(status) {
      const statusColors = [
        'gray-2',
        'sweetCorn',
        'bg-secondary-38',
        'bg-secondary-38',
      ];
      return 'dot ' + statusColors[Number(status.id) - 1];
    },
    onPageChange(page) {
      this.$emit('on-page-change', page);
    },
    openDetails(item, option) {
      if (
        (this.selectedOption !== option && !item.item.isOpen) ||
        this.selectedOption == option
      ) {
        this.toggleOpen(item.index);
      }
      this.selectedOption = option;
    },
    doSearch() {
      this.$emit('do-search');
    },
    goToEdit(id) {
      this.$router.push({
        name: 'materialAddRequisition',
        params: { requestId: id },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.balloon {
  padding: 6px;
  background: #fdfcf4 0% 0% no-repeat padding-box;
  border-radius: 20px;
  opacity: 1;
}
.dot {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  display: inline-block;
}
.sweetCorn {
  background-color: #f8eb7f;
}
.bg-secondary-38 {
  background-color: #f8b184;
}
.bg-secondary-23 {
  background-color: #f8eb7f;
}
.bg-green-light {
  background-color: #a4e5b2;
}
.bg-brown {
  background-color: #d5b89a;
}
.gray-2 {
  background-color: #b5c3bc;
}
</style>
